import React, { useEffect, useState } from 'react';


import slide1 from '../assets/img/slide1.jpg';
import slide2 from '../assets/img/slide2.jpg';
import slide3 from '../assets/img/slide3.jpg';
import slide4 from '../assets/img/slide4.jpg';

import Testi1 from '../assets/img/testi1.jpg';
import Testi2 from '../assets/img/testi2.jpg';
import Testi3 from '../assets/img/testi3.jpg';
import Testi4 from '../assets/img/testi4.jpg';
import Testi5 from '../assets/img/testi5.jpg';
import Testi6 from '../assets/img/testi6.jpg';

import Insta from '../assets/img/insta.png';
import Youtube from '../assets/img/youtube.png';

import Trsimggg from '../assets/img/one-on-one.png';

import Insta1 from '../assets/img/ins1.png';
import Insta2 from '../assets/img/ins2.png';
import Insta3 from '../assets/img/ins3.png';
import Insta4 from '../assets/img/ins4.png';
import Insta5 from '../assets/img/ins5.png';
import Gmailicon from '../assets/img/gmail.png';
import Phoneicon from '../assets/img/phone.png';
import Trsimg from '../assets/img/trsimmg.png';

import Video1 from '../assets/video/video1.mp4';
import Video2 from '../assets/video/video2.mp4';
import Video3 from '../assets/video/video3.mp4';
import Video4 from '../assets/video/video4.mp4';

import Playbtn from '../assets/img/play.png';
import SeoHelmet from "../components/SeoHelmet";

const HomePage = () => {
 
  const [activeVideo, setActiveVideo] = useState(null);

  const handleOpenModal = (videoSrc) => {
    setActiveVideo(videoSrc); // Set the active video source
  };

  const handleCloseModal = () => {
    setActiveVideo(null); // Clear the active video source
  };
 
    useEffect(() => {
       
        if (window.Swiper) {
          
          const swiperQuiz = new window.Swiper(".animeslide", {
            effect: "fade",
            loop: true,
            autoplay: 5000,
            speed: 900,
            autoplay: {
              delay: 2800,
            },
            centeredSlides: true,
            pagination: {
              el: ".animeslide-pagination",
              clickable: true,
            },
            navigation: {
              nextEl: ".animeslide-button-next",
              prevEl: ".animeslide-button-prev",
            },
            
            keyboard: {
              enabled: true,
              onlyInViewport: false,
            },
            runCallbacksOnInit: true,
          });
    
          
          const swiper = new window.Swiper(".instpostslide", {
            loop: true,
            slidesPerView: 1,
            navigation: {
              nextEl: ".testi-button-next",
              prevEl: ".testi-button-prev",
            },
            breakpoints: {
              768: {
                slidesPerView: 4, 
                spaceBetween: 30,
                navigation: {
                  nextEl: ".testi-button-next",
                  prevEl: ".testi-button-prev",
                },
              },
              // You can add more breakpoints if needed
            },
          
          });
        }

       


      }, []); 
    
  return (

    <>
 <SeoHelmet />

 


    <section>
      <div className="swiper animeslide">
        <div className="swiper-wrapper">
          <div className="swiper-slide animeslide-slide slide4" style={{ backgroundImage: `url(${slide4})` }}>
            <div className="container">
              <div className="content-slide">
                <div data-animate="bottom" className="animeslide-heading">
                  <h2>Bhavana Singh </h2>
                  <h3>Transform with Bhavana <br></br>Next Batch 6oct-12th oct</h3>
                </div>
                <div data-animate="bottom" className="animeslide-desc">
                  <a href="https://www.youtube.com/@bhavnasingh555"><img src={Youtube} alt=""/><span> Youtube</span></a>
                  <a href="https://www.instagram.com/bhavna555/?hl=en"><img src={Insta} alt=""/><span> Instagram</span></a>
                </div>
              </div>
            </div>
          </div>
          <div className="swiper-slide animeslide-slide slide1" style={{ backgroundImage: `url(${slide1})` }}>
            <div className="container">
              <div className="content-slide">
                <div data-animate="bottom" className="animeslide-heading">
                  <h2>Bhavana Singh </h2>
                  <h3>Stylist | Designer | Personality Transformation Coach </h3>
                </div>
                <div data-animate="bottom" className="animeslide-desc">
                  <a href="https://www.youtube.com/@bhavnasingh555"><img src={Youtube} alt=""/><span> Youtube</span></a>
                  <a href="https://www.instagram.com/bhavna555/?hl=en"><img src={Insta} alt=""/><span> Instagram</span></a>
                </div>
              </div>
            </div>
          </div>
          <div className="swiper-slide animeslide-slide slide2" style={{ backgroundImage: `url(${slide2})` }}>
            <div className="container">
              <div className="content-slide">
                <div data-animate="bottom" className="animeslide-heading">
                  <h2>Bhavana Singh </h2>
                  <h3>Stylist | Designer | Personality Transformation Coach </h3>
                </div>
                <div data-animate="bottom" className="animeslide-desc">
                <a href="https://www.youtube.com/@bhavnasingh555"><img src={Youtube} alt=""/><span> Youtube</span></a>
                <a href="https://www.instagram.com/bhavna555/?hl=en"><img src={Insta} alt=""/><span> Instagram</span></a>
                </div>
              </div>
            </div>
          </div>
          <div className="swiper-slide animeslide-slide slide3" style={{ backgroundImage: `url(${slide3})` }}>
            <div className="container">
              <div className="content-slide">
                <div data-animate="bottom" className="animeslide-heading">
                  <h2>Bhavana Singh </h2>
                  <h3>Stylist | Designer | Personality Transformation Coach </h3>
                </div>
                <div data-animate="bottom" className="animeslide-desc">
                <a href="https://www.youtube.com/@bhavnasingh555"><img src={Youtube} alt=""/><span> Youtube</span></a>
                <a href="https://www.instagram.com/bhavna555/?hl=en"><img src={Insta} alt=""/><span> Instagram</span></a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="flex animeslide-bottom">
          <div className="animeslide-pagination swiper-pagination"></div>
        </div>
      </div>
    </section>
    <section className="about_part">
        <div className="container">
            <div className="about_section">
                <h2>About Bhavana Singh</h2>
                <p>Bhavana Singh is a personal transformation coach and motivator, guiding clients to embrace their true selves with confidence. Beyond styling and design, she empowers individuals to unlock their potential and express their unique identity with authenticity and pride.</p>
                <div className='btngro'>
                  <a href="/about-us"><span>learn more</span></a>
                  <a href="#" data-bs-toggle="modal" data-bs-target="#staticBackdrop"><span>Enrol Now</span></a>
                </div>
            </div>
        </div>
    </section>
    <div class="modal fade" id="staticBackdrop" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          
          <div class="modal-body">
            <div className='formouter'>
              <div className='formcontent'>
                  <form  className="contact_form modalform">
                    <h2>Send a message</h2>
                  <div className="row">
                    <div className="col-sm-6">
                      <input type="text" name="fname" className="form-control" placeholder="Your Name" required />
                    </div>
                    <div className="col-sm-6">
                      <input type="email" name="email" className="form-control" placeholder="Your Email" required />
                    </div>
                    <div className="col-sm-6">
                      <input type="number" name="number" className="form-control" placeholder="Your Phone" required />
                    </div>
                    <div className="col-sm-6">
                      <input type="text" name="subject" className="form-control" placeholder="Subject" required />
                    </div>
                  
                    <div className="col-sm-12">
                      <textarea name="message" className="messagebox" placeholder="Message"></textarea>
                    </div>
                  </div>
                  <button type="submit" className="btn btn-form">
                    Send Now
                  </button>
                </form>
              </div>
              <div className='forminfo'>
                <a href='tel:919899604722'><img src={Phoneicon} alt=""/> +91-9899604722</a>
                <a href='info:infobhavanasingh@gmail.com'><img src={Gmailicon} alt=""/> Infobhavanasingh@gmail.com</a>
              </div>
            </div>
          </div>
          
        </div>
      </div>
    </div>
    <section className="join_part">
        <div className="container">
        <div class="breaking-news">
  
        <div class="breaking-news__marquee">
          <div class="breaking-news__inner">
            <span><a href="/personality-development-courses"><p>Join Transform with Bhavana Singh | 2 Weeks Intensive Program 6oct-12th oct</p></a></span>
            <span><a href="/personality-development-courses"><p>Join Transform with Bhavana Singh | 2 Weeks Intensive Program 6oct-12th oct</p></a></span>
          </div>
        </div>
      </div>

        </div>
    </section>

    <section className="transform hometrns">
        
        <div className="container">
            <div className="row">
                <div className="col-md-7">
                    <div className="trans_content">
                      <img src={Trsimg} className='mobiletrns'></img>
                        <div className="heading">
                            <span className='trnhembr'>Transform</span>
                            <span className='trnbhambr'>With Bhavana Singh</span>
                        </div>
                        <ul>
                            <li>
                                <span>1. Enrol in the Class:</span>
                                <p>Sign up for Bhavana Singh’s program and commit to your style transformation journey.
                                </p>
                            </li>
                            <li>
                                <span>2. Hands on Training:</span>
                                <p>Engage in hands-on sessions focused on confidence-building, enhancing body language
                                    and styling.</p>
                            </li>
                            <li>
                                <span>3. Experience the Transformation:</span>
                                <p>Apply your new skills in real-world scenarios, emerging with a refreshed style and
                                    boosted confidence.</p>
                            </li>
                        </ul>
                        <div className='btngro'>
                          <a href="/personality-development-courses"><span>learn more</span></a>
                          <a href="#" data-bs-toggle="modal" data-bs-target="#staticBackdrop"><span>Enrol Now</span></a>
                        </div>
                       
                    </div>
                </div>
                <div className="col-md-5">
                  <div className='trsbg'>
                    {/* <img src={Trsimg} /> */}
                  </div>
                </div>
            </div>
        </div>
        <span class="aftersh"></span>
    </section>

    <section className="transform one-on-one">
        
        <div className="container">
            <div className="row">
                <div className="col-md-6">
                  
                </div>
                <div className="col-md-6">
                <img src={Trsimggg} className='mobiletrns'></img>
                    <div className="one-heading">
                        <h2>One-on-One<br></br>&nbsp;&nbsp;&nbsp; Transformation</h2>
                        <h3>With Bhavana Singh</h3>
                        <p>Transform with Bhavana!</p>
                    </div>
                    <div className='one-content'>
                      <p>Are you ready to elevate your style, confidence, and<br></br> personality?</p>
                      <p>Bhavana Singh, a renowned Personality Transformation<br></br> Coach, offers exclusive One-on-One Customized<br></br> Transformation Sessions to help you look and feel your<br></br> absolute best.</p>
                    </div>
                    <div className='btngro'>
                      <a href="/one-on-one-transformation"><span>learn more</span></a>
                      <a href="#" data-bs-toggle="modal" data-bs-target="#staticBackdrop"><span>Enrol Now</span></a>
                    </div>
                </div>
            </div>
        </div>
        
    </section>

    <section className="testimonals">
        <div className="container">
            <div className="testi_head">
                <h2>Testimonials - Personal Transformation Course</h2>
            </div>
            <div className="swiper instpostslide">
                <div className="swiper-wrapper">
                    
                    <div className="swiper-slide"><a href='#'  onClick={() => handleOpenModal(Video2)} data-bs-toggle="modal" data-bs-target="#videoModal"><img className="slidehimg" src={Testi3} /><img className='playbtnv' src={Playbtn}></img></a></div>
                    <div className="swiper-slide"><a href='#'  onClick={() => handleOpenModal(Video3)} data-bs-toggle="modal" data-bs-target="#videoModal"><img className="slidehimg" src={Testi4} /><img className='playbtnv' src={Playbtn}></img></a></div>
                    <div className="swiper-slide"><a href='#'  onClick={() => handleOpenModal(Video1)} data-bs-toggle="modal" data-bs-target="#videoModal"><img className="slidehimg" src={Testi5} /><img className='playbtnv' src={Playbtn}></img></a></div>
                    <div className="swiper-slide"><a href='#'  onClick={() => handleOpenModal(Video4)} data-bs-toggle="modal" data-bs-target="#videoModal"><img className="slidehimg" src={Testi6} /><img className='playbtnv' src={Playbtn}></img></a></div>
                    
                    <div className="swiper-slide"><a href='#'  onClick={() => handleOpenModal(Video2)} data-bs-toggle="modal" data-bs-target="#videoModal"><img className="slidehimg" src={Testi3} /><img className='playbtnv' src={Playbtn}></img></a></div>
                    <div className="swiper-slide"><a href='#'  onClick={() => handleOpenModal(Video3)} data-bs-toggle="modal" data-bs-target="#videoModal"><img className="slidehimg" src={Testi4} /><img className='playbtnv' src={Playbtn}></img></a></div>
                    <div className="swiper-slide"><a href='#'  onClick={() => handleOpenModal(Video1)} data-bs-toggle="modal" data-bs-target="#videoModal"><img className="slidehimg" src={Testi5} /><img className='playbtnv' src={Playbtn}></img></a></div>
                    <div className="swiper-slide"><a href='#'  onClick={() => handleOpenModal(Video4)} data-bs-toggle="modal" data-bs-target="#videoModal"><img className="slidehimg" src={Testi6} /><img className='playbtnv' src={Playbtn}></img></a></div>
                  
                </div>
                <div>
                  <div className="testi-button-next swiper-button-next"></div>
                  <div className="testi-button-prev swiper-button-prev"></div>
                </div>
            </div>
        </div>
    </section>
   
    <div
        className={`modal fade ${activeVideo ? "show" : ""}`}
        id="videoModal"
        tabIndex="-1"
        aria-labelledby="videoModalLabel"
        aria-hidden={!activeVideo}
        style={{ display: activeVideo ? "block" : "none" }}
        onClick={(e) => {
          if (e.target.classList.contains("modal")) {
            handleCloseModal();
          }
        }}
      >
        <div className="modal-dialog modal-dialog-centered video_sectio">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="videoModalLabel">Bhavana Singh</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={handleCloseModal}
              ></button>
            </div>
            <div className="modal-body">
              {activeVideo && (
                <iframe
                  id="videoFrame"
                  width="100%"
                  height="500"
                  src={`${activeVideo}#t=0&autoplay=1`}
                  frameBorder="0"
                  allow="autoplay"
                  allowFullScreen
                ></iframe>
              )}
            </div>
          </div>
        </div>
      </div>
     
   
    <section className="instagram">
        <div className="container">
            <div className="insta_head">
                <div>
                    <h2>Follow</h2>
                    <h3>Our</h3>
                </div>
                <div>
                    <h4>Instagram</h4>
                </div>
            </div>
        </div>
        <div className="instafeed">
            <img src={Insta1} alt="" />
            <img src={Insta2} alt=""/>
            <img src={Insta3} alt=""/>
            <img src={Insta4} alt=""/>
            <img src={Insta5} alt=""/>
        </div>
    </section>

</>



  );
};

export default HomePage;
